export const CHANGE_PRODUCT_CURRENT = 'CHANGE_PRODUCT_CURRENT'